export default "__VITE_ASSET__CuV72UIQ__"